import { FormattedMessage } from 'react-intl';

export const hookMessages = {
  'hooks.organisationSettingsApi.fetchError': (
    <FormattedMessage
      id="hooks.organisationSettingsApi.fetchError"
      defaultMessage="Error fetching your organisation configurations. Please refresh your browser to try again."
    />
  ),
  'hooks.facebookFeed.fetchError': (
    <FormattedMessage
      id="hooks.facebookFeed.fetchError"
      defaultMessage="Failed to fetch Facebook posts."
    />
  ),
  'hooks.facebookFeed.missingParams': (
    <FormattedMessage
      id="hooks.facebookFeed.missingParams"
      defaultMessage="Missing page ID or access token."
    />
  ),
};

export const useGetAuthorisedRepresentativesByEnterpriseIdMessages = {
  'useGetAuthorisedRepresentativesByEnterpriseId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetAuthorisedRepresentativesByEnterpriseId.fetch.unexpectedError"
      defaultMessage="Error loading authorised representatives, please refresh your browser or contact support."
    />
  ),
};

export const useGetEnterpriseMessages = {
  'useGetEnterprise.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetEnterprise.fetch.unexpectedError"
      defaultMessage="Error loading enterprise, please refresh your browser or contact support."
    />
  ),
};

export const useGetEnterprisesByUserIdMessages = {
  'useGetEnterprisesByUserId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetEnterprisesByUserId.fetch.unexpectedError"
      defaultMessage="Error loading your enterprises, please refresh your browser or contact support."
    />
  ),
};

export const useGetEnterpriseActionsMessages = {
  'useGetEnterpriseActions.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetEnterpriseActions.fetch.unexpectedError"
      defaultMessage="Error loading enterprise actions, please refresh your browser or contact support."
    />
  ),
};

export const useGetMembershipMessages = {
  'useGetMembership.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetMembership.fetch.unexpectedError"
      defaultMessage="Error loading your membership, please refresh your browser or contact support."
    />
  ),
};

export const useGetMembershipsByEnterpriseIdMessages = {
  'useGetMembershipsByEnterpriseId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetMembershipsByEnterpriseId.fetch.unexpectedError"
      defaultMessage="Error loading memberships, please refresh your browser or contact support."
    />
  ),
};

export const useGetMembershipsByUserIdMessages = {
  'useGetMembershipsByUserId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetMembershipsByUserId.fetch.unexpectedError"
      defaultMessage="Error loading memberships, please refresh your browser or contact support."
    />
  ),
};

export const useGetOrganisationsByUserIdMessages = {
  'useGetOrganisationsByUserId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetOrganisationsByUserId.fetch.unexpectedError"
      defaultMessage="Error loading organisations associated to the user. Please refresh your browser or contact support."
    />
  ),
};

export const useGetOrganisationsMessages = {
  'useGetOrganisations.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetOrganisations.fetch.unexpectedError"
      defaultMessage="Error loading organisations, please refresh your browser or contact support."
    />
  ),
};

export const useGetOrganisationByEntityIdMessages = {
  'useGetOrganisationByEntityId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetOrganisationByEntityId.fetch.unexpectedError"
      defaultMessage="Error loading organisation, please refresh your browser or contact support."
    />
  ),
};

export const useGetOrganisationByEnterpriseIdMessages = {
  'useGetOrganisationByEnterpriseId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetOrganisationByEnterpriseId.fetch.unexpectedError"
      defaultMessage="Error loading organisation, please refresh your browser or contact support."
    />
  ),
};

export const useGetOrganisationSettingsMessages = {
  'useGetOrganisationSettings.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetOrganisationSettings.fetch.unexpectedError"
      defaultMessage="Error loading organisation settings, please refresh your browser or contact support."
    />
  ),
};

export const useGetPrefixesByEnterpriseIdMessages = {
  'useGetPrefixesByEnterpriseId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetPrefixesByEnterpriseId.fetch.unexpectedError"
      defaultMessage="Error loading prefixes, please refresh your browser or contact support."
    />
  ),
};

export const useGetPrefixesByOrganisationIdMessages = {
  'useGetPrefixesByOrganisationId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetPrefixesByOrganisationId.fetch.unexpectedError"
      defaultMessage="Error loading prefixes, please refresh your browser or contact support."
    />
  ),
};

export const useGetAnimalByEntityIdMessages = {
  'useGetAnimalByEntityId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetAnimalByEntityId.fetch.unexpectedError"
      defaultMessage="Error loading animal, please refresh your browser or contact support."
    />
  ),
};

export const useGetAnimalSpeciesMessages = {
  'useGetAnimalSpecies.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetAnimalSpecies.fetch.unexpectedError"
      defaultMessage="Error loading animal species, please refresh your browser or contact support."
    />
  ),
};

export const useGetAnimalTraitsMessages = {
  'useGetAnimalTraits.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetAnimalTraits.fetch.unexpectedError"
      defaultMessage="Error loading traits, please refresh your browser or contact support."
    />
  ),
};

export const useGetAnimalTraitCategoriesMessages = {
  'useGetAnimalTraitCategories.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetAnimalTraitCategories.fetch.unexpectedError"
      defaultMessage="Error loading trait categories, please refresh your browser or contact support."
    />
  ),
};

export const useReadCustomFormForEntityIdMessages = {
  'useReadCustomFormForEntityId.fetch.unexpectedError': (
    <FormattedMessage
      id="useReadCustomFormForEntityId.fetch.unexpectedError"
      defaultMessage="Error loading custom form, please refresh your browser or contact support."
    />
  ),
};
